(function () {
  
  function initCustomCheckoutSection(sectionId) {
    const root = document.getElementById("CustomCheckout-" + sectionId);

    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
    const container = root.querySelector(".custom-checkout");
    const form = root.querySelector(".custom-checkout__form");
    const itemsNode = root.querySelector("[data-checkout-items]");
    const alertNode = root.querySelector("[data-checkout-alert]");
    const subtotalNode = root.querySelector("[data-subtotal]");
    const deliveryNode = root.querySelector("[data-delivery]");
    const deliveryLabelNode = root.querySelector("[data-delivery-label-node]");
    const discountNode = root.querySelector("[data-discount]");
    const discountLabelNode = root.querySelector("[data-discount-label]");
    const discountRowNode = root.querySelector("[data-discount-row]");
    const totalNode = root.querySelector("[data-total]");
    const districtSelect = root.querySelector("[data-district-select]");
    const thanaSelect = root.querySelector("[data-thana-select]");
    const phoneInput = form.querySelector('input[name="phone"]');
    const codLabelNode = root.querySelector("[data-cod-label]");
    const paymentButtons = Array.from(
      root.querySelectorAll("[data-payment-value]"),
    );
    const submitButton = root.querySelector("[data-submit-button]");
    const continueShoppingButton = root.querySelector(
      "[data-continue-shopping-button]",
    );
    const couponToggleButton = root.querySelector("[data-coupon-toggle]");
    const couponPanelNode = root.querySelector("[data-coupon-panel]");
    const couponInput = root.querySelector("[data-coupon-input]");
    const couponApplyButton = root.querySelector("[data-coupon-apply]");
    const quantityOffersRoot = root.querySelector(
      "[data-quantity-offers-root]",
    );
    const submitLabelNode = root.querySelector("[data-submit-label]");
    const submitDotsNode = root.querySelector("[data-submit-dots]");
    const progressContainer = root.querySelector(
      "[data-free-delivery-progress]",
    );
    const formElements = form.elements;
    const currencyCode = container.dataset.currencyCode || "BDT";
    const fallbackDeliveryFee = Number(container.dataset.deliveryFee || 0);
    const dhakaDeliveryFee = Number(
      container.dataset.dhakaDeliveryFee || fallbackDeliveryFee,
    );
    const otherDeliveryFee = Number(
      container.dataset.otherDeliveryFee || fallbackDeliveryFee,
    );
    const dhakaSubareaDeliveryFee = Number(
      container.dataset.dhakaSubareaDeliveryFee || 0,
    );
    const freeDeliveryItemThreshold = Math.max(
      0,
      Number(container.dataset.freeDeliveryItemThreshold || 0),
    );
    const enableFreeDeliveryBySubtotal =
      container.dataset.enableFreeDeliveryBySubtotal === "true";
    const freeDeliverySubtotalAmount = Math.round(
      Number(container.dataset.freeDeliverySubtotalAmount || 1200) * 100,
    );
    const freeDeliverySubtotalPriority =
      container.dataset.freeDeliverySubtotalPriority !== "false";
    const dhakaDistrictName = String(
      container.dataset.dhakaDistrictName || "Dhaka",
    )
      .trim()
      .toLowerCase();
    const codLabelDhaka =
      container.dataset.codLabelDhaka ||
      container.dataset.codLabelOther ||
      "Cash on delivery";
    const codLabelOther = container.dataset.codLabelOther || "Cash on delivery";
    const deliveryLabelDhaka =
      container.dataset.deliveryLabelDhaka ||
      container.dataset.deliveryLabel ||
      "Inside Dhaka";
    const deliveryLabelSubarea =
      container.dataset.deliveryLabelSubarea ||
      container.dataset.deliveryLabelDhaka ||
      "Dhaka sub area";
    const deliveryLabelOther =
      container.dataset.deliveryLabelOther ||
      container.dataset.deliveryLabel ||
      "Outside Dhaka";
    const useCartFallback = container.dataset.useCartFallback !== "false";
    const continueShoppingUrl = container.dataset.continueShoppingUrl || "/";
    const emptyStateText =
      container.dataset.emptyStateText || "No product selected";
    const postOrderBehavior = String(
      container.dataset.postOrderBehavior || "redirect",
    )
      .trim()
      .toLowerCase();
    const useThankYouPopup = postOrderBehavior === "popup";
    const getThankYouHost = () =>
      container.dataset.thankYouHost === "external"
        ? document.querySelector("[data-custom-checkout-thankyou]")
        : container;
    const getThankYouParts = () => {
      const host = getThankYouHost();
      if (!host) return null;
      return {
        overlay: host.querySelector("[data-thankyou-overlay]"),
        dialog: host.querySelector("[data-thankyou-dialog]"),
        closeEl: host.querySelector("[data-thankyou-close]"),
        titleEl: host.querySelector("[data-thankyou-title]"),
        messageEl: host.querySelector("[data-thankyou-message]"),
        orderLineEl: host.querySelector("[data-thankyou-order-line]"),
        statusLinkEl: host.querySelector("[data-thankyou-status-link]"),
        continueEl: host.querySelector("[data-thankyou-continue]"),
      };
    };
    const genericErrorMessage =
      container.dataset.genericError ||
      "Something went wrong while preparing your checkout. Please try again.";
    const couponDiscountEndpoint =
      container.dataset.couponDiscountEndpoint || "/api/discount/code";
    const quantityOffersConfigRaw = container.dataset.quantityOffers || "";
    const state = {
      items: [],
      selectedPayment: container.dataset.defaultPayment || "cash_on_delivery",
      districts: {},
      upazilas: {},
      couponCode: null,
      couponDiscount: null,
      couponApplying: false,
      quantityOffersConfig: null,
      quantityOfferCampaign: null,
      selectedQuantityOfferId: null,
      syncing: false,
      submitSequenceTimer: null,
      submitSequenceCancelled: false,
      suppressSubmitReset: false,
    };
    const locationOverrides = {
      upazilas: {
        26: [
          { value: 548, title: "Adabor" },
          { value: 506, title: "Airport Thana" },
          { value: 574, title: "Ashulia" },
          { value: 524, title: "Badda" },
          { value: 549, title: "banani" },
          { value: 513, title: "Banani" },
          { value: 511, title: "Bhasantek" },
          { value: 544, title: "Bongshal" },
          { value: 523, title: "Cantonment" },
          { value: 532, title: "Chawkbazar" },
          { value: 519, title: "Dakkhinkhan" },
          { value: 518, title: "Darus Salam" },
          { value: 542, title: "Demra" },
          { value: 366, title: "Dhamrai" },
          { value: 502, title: "Dhanmondi" },
          { value: 369, title: "Dohar" },
          { value: 547, title: "Gendaria" },
          { value: 507, title: "Gulshan" },
          { value: 540, title: "Hajaribaag" },
          { value: 578, title: "Hatirjheel" },
          { value: 505, title: "Jatrabari" },
          { value: 501, title: "Kafrul Thana" },
          { value: 533, title: "Kamrangirchor" },
          { value: 367, title: "Keraniganj" },
          { value: 539, title: "khilgaon" },
          { value: 500, title: "Khilkhet" },
          { value: 531, title: "Kodomtoli" },
          { value: 536, title: "Kolabagan" },
          { value: 534, title: "Kotwali" },
          { value: 535, title: "Laalbag" },
          { value: 517, title: "Mirpur" },
          { value: 503, title: "Mohammadpur" },
          { value: 538, title: "Motijheel" },
          { value: 509, title: "Mugda" },
          { value: 368, title: "Nawabganj" },
          { value: 545, title: "New Market" },
          { value: 525, title: "Pallabi" },
          { value: 543, title: "Paltan Model Thana" },
          { value: 529, title: "Rampura" },
          { value: 541, title: "Romna Model Thana" },
          { value: 510, title: "Rupnagar" },
          { value: 530, title: "Sabujbag" },
          { value: 365, title: "Savar" },
          { value: 526, title: "Shah Ali" },
          { value: 537, title: "Shahbag" },
          { value: 515, title: "Shahjahanpur" },
          { value: 546, title: "Shampur" },
          { value: 516, title: "Sher-e-bangla" },
          { value: 504, title: "Sutrapur" },
          { value: 528, title: "Tejgaon" },
          { value: 527, title: "Tejgaon Industrial Area" },
          { value: 521, title: "Turag" },
          { value: 508, title: "Uttara" },
          { value: 522, title: "Uttara Model Thana" },
          { value: 520, title: "Uttarkhan" },
          { value: 512, title: "Vatara" },
          { value: 514, title: "Wari" },
        ],
        33: [
          { value: 3301, title: "Bason" },
          { value: 3302, title: "Gacha Thana" },
          { value: 320, title: "Gazipur Sadar" },
          { value: 3303, title: "Joydevpur" },
          { value: 318, title: "Kaliakair" },
          { value: 317, title: "Kaliganj" },
          { value: 319, title: "Kapasia" },
          { value: 3304, title: "Kashimpur" },
          { value: 3305, title: "Konabari" },
          { value: 3306, title: "Pubail" },
          { value: 321, title: "Sreepur" },
          { value: 3307, title: "Tongi" },
        ],
        67: [
          { value: 328, title: "Araihazar" },
          { value: 329, title: "Bandar" },
          { value: 9006, title: "Fatullah" },
          { value: 330, title: "Narayanganj Sadar" },
          { value: 331, title: "Rupganj" },
          { value: 9004, title: "Siddhirganj" },
          { value: 332, title: "Sonargaon" },
        ],
        subsarea: [
          { value: 9001, title: "Ashulia" },
          { value: 9004, title: "Dhamrai" },
          { value: 9005, title: "Dohar" },
          { value: 9008, title: "Savar Industrial Area" },
          { value: 9009, title: "Ashulia" },
          { value: 9010, title: "Hemayetpur" },
          { value: 9011, title: "Savar" },
          { value: 9012, title: "Keraniganj Model" },
          { value: 9013, title: "Nawabganj" },
          { value: 9014, title: "South Keraniganj" },
        ],
      },
    };
    const submitButtonDefaultLabel =
      submitLabelNode?.textContent?.trim() ||
      container.dataset.placeOrderLabel ||
      "Place order";
    const submitSteps = [
      "Verifying details",
      "Creating order",
      "Finalizing order",
      "Order confirmed! Redirecting",
    ];
    const moneyFormatter = new Intl.NumberFormat("en-BD", {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: 2,
    });

    // Helper functions
    const formatMoney = (cents) => {
      return moneyFormatter.format(Number(cents || 0) / 100);
    };

    const toTitleCase = (value = "") => {
      return String(value)
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    const toSafeNumber = (value, fallback = 0) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const toCents = (value) => {
      const numericValue = toSafeNumber(value, 0);
      return Number.isInteger(numericValue) && numericValue > 999
        ? numericValue
        : Math.round(numericValue * 100);
    };

    const parseJsonSafe = (value, fallback = null) => {
      try {
        return JSON.parse(value);
      } catch {
        return fallback;
      }
    };

    const checkoutControls = Array.from(
      form.querySelectorAll("input, select, textarea"),
    );
    const subareaItems = Array.isArray(locationOverrides.upazilas.subsarea)
      ? locationOverrides.upazilas.subsarea
      : [];
    const subareaValues = new Set(
      subareaItems.map((item) => String(item.value)),
    );

    const normalizePhoneNumber = (value = "") => {
      return value.trim().replace(/^\+88(?=01\d{9}$)/, "");
    };

    const syncPhoneInput = () => {
      if (!phoneInput) return "";
      const normalizedPhone = normalizePhoneNumber(phoneInput.value);
      if (phoneInput.value !== normalizedPhone) {
        phoneInput.value = normalizedPhone;
      }
      return normalizedPhone;
    };

    const setAlert = (message) => {
      if (alertNode) {
        alertNode.textContent = message || "";
        alertNode.classList.toggle("hidden", !message);
      }
    };

    const clearSubmitSequenceTimer = () => {
      if (!state.submitSequenceTimer) return;
      window.clearTimeout(state.submitSequenceTimer);
      state.submitSequenceTimer = null;
    };

    const setSubmitButtonState = (label, showDots = false) => {
      if (submitLabelNode) {
        submitLabelNode.textContent = label;
      }
      if (submitDotsNode) {
        submitDotsNode.classList.toggle("hidden", !showDots);
      }
    };

    const resetSubmitButtonState = () => {
      state.submitSequenceCancelled = true;
      clearSubmitSequenceTimer();
      setSubmitButtonState(submitButtonDefaultLabel, false);
    };

    const runSubmitSequence = () => {
      state.submitSequenceCancelled = false;
      let stepIndex = 0;
      return new Promise((resolve) => {
        const advance = () => {
          if (state.submitSequenceCancelled) {
            resolve();
            return;
          }
          if (submitButton) submitButton.disabled = true;
          setSubmitButtonState(submitSteps[stepIndex], true);
          if (stepIndex >= submitSteps.length - 1) {
            state.submitSequenceTimer = null;
            resolve();
            return;
          }
          stepIndex += 1;
          state.submitSequenceTimer = window.setTimeout(advance, 1200);
        };
        advance();
      });
    };

    const params = new URLSearchParams(window.location.search);
    const productParam = params.get("product") || "";
    const productHandle = productParam
      .replace(/^\/?products\//, "")
      .replace(/\/$/, "");
    const productId = /^\d+$/.test(productParam) ? productParam : "";
    const variantId = params.get("variant") || "";
    const requestedQuantity = Math.max(1, Number(params.get("quantity") || 1));

    const fetchJson = async (url, options = {}) => {
      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        ...options,
      });

      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      return response.json();
    };

    const parseNamedConst = (source, constName) => {
      const marker = `const ${constName} =`;
      const start = source.indexOf(marker);
      if (start === -1) return null;

      let index = start + marker.length;
      while (index < source.length && /\s/.test(source[index])) index += 1;

      const openChar = source[index];
      const closeChar = openChar === "[" ? "]" : openChar === "{" ? "}" : "";
      if (!closeChar) return null;

      let depth = 0;
      let inString = false;
      let stringQuote = "";
      let escaped = false;
      let end = index;

      for (; end < source.length; end += 1) {
        const char = source[end];

        if (inString) {
          if (escaped) {
            escaped = false;
          } else if (char === "\\") {
            escaped = true;
          } else if (char === stringQuote) {
            inString = false;
            stringQuote = "";
          }
          continue;
        }

        if (char === '"' || char === "'") {
          inString = true;
          stringQuote = char;
          continue;
        }
        if (char === openChar) depth += 1;
        if (char === closeChar) {
          depth -= 1;
          if (depth === 0) {
            end += 1;
            break;
          }
        }
      }

      const rawValue = source.slice(index, end).trim();
      if (!rawValue) return null;

      try {
        return JSON.parse(rawValue);
      } catch (error) {
        return null;
      }
    };

    const loadLocationData = async () => {
      const cacheKey = "custom_checkout_location_data";
      let source = null;
      try {
        source = sessionStorage.getItem(cacheKey);
      } catch (e) {}

      if (!source) {
        const response = await fetch(container.dataset.locationUrl);
        if (!response.ok) throw new Error("location-data");
        source = await response.text();
        try {
          sessionStorage.setItem(cacheKey, source);
        } catch (e) {}
      }

      state.districts = parseNamedConst(source, "districts_en") || {};
      state.upazilas = parseNamedConst(source, "upazilas_en") || {};
      Object.entries(locationOverrides.upazilas).forEach(
        ([districtId, overrideItems]) => {
          if (districtId === "subsarea") return;
          const resolvedOverrideItems =
            String(districtId) === "26" &&
            Array.isArray(locationOverrides.upazilas.subsarea)
              ? overrideItems.concat(locationOverrides.upazilas.subsarea)
              : overrideItems;
          const existingItems = Array.isArray(state.upazilas[districtId])
            ? state.upazilas[districtId]
            : [];
          const filteredExistingItems =
            String(districtId) === "26"
              ? existingItems.filter(
                  (item) => !["492", "493"].includes(String(item?.value || "")),
                )
              : String(districtId) === "33"
                ? existingItems.filter(
                    (item) => String(item?.value || "") !== "499",
                  )
                : String(districtId) === "67"
                  ? existingItems.filter(
                      (item) => String(item?.value || "") !== "500",
                    )
                  : existingItems;
          const mergedByTitle = new Map();

          filteredExistingItems
            .concat(resolvedOverrideItems)
            .forEach((item) => {
              const titleKey = String(item?.title || "")
                .trim()
                .toLowerCase();
              if (!titleKey) return;
              mergedByTitle.set(titleKey, {
                ...item,
                title: toTitleCase(item?.title || ""),
              });
            });

          state.upazilas[districtId] = Array.from(mergedByTitle.values()).sort(
            (left, right) =>
              String(left.title || "").localeCompare(
                String(right.title || ""),
                "en",
                { sensitivity: "base" },
              ),
          );
        },
      );

      if (!Object.keys(state.districts).length) {
        throw new Error("location-data");
      }
    };

    const renderComboboxOptions = (select, items) => {
      const combobox = select.closest('[data-combobox]');
      if (!combobox) return;
      const list = combobox.querySelector('[data-combobox-list]');
      const input = combobox.querySelector('[data-combobox-input]');
      if (!list || !input) return;

      input.disabled = items.length === 0;
      if (items.length === 0) {
        input.value = "";
      }

      list.innerHTML = items.map(item => `
        <div class="custom-checkout__combobox-option" data-value="${String(item.value)}" data-title="${item.title}">
          <strong>${item.title}</strong>
        </div>
      `).join('');
    };

    const renderSelectOptions = (
      select,
      items,
      placeholder,
      selectedValue = "",
    ) => {
      if (!select) return;
      select.disabled = items.length === 0;
      select.innerHTML = [`<option value="">${placeholder}</option>`]
        .concat(
          items.map((item) => {
            const selected =
              String(item.value) === String(selectedValue) ? " selected" : "";
            return `<option value="${String(item.value)}"${selected}>${item.title}</option>`;
          }),
        )
        .join("");

      renderComboboxOptions(select, items);

      const combobox = select.closest('[data-combobox]');
      if (combobox) {
        const input = combobox.querySelector('[data-combobox-input]');
        if (input && selectedValue) {
           const selectedItem = items.find(i => String(i.value) === String(selectedValue));
           if (selectedItem) input.value = selectedItem.title;
        } else if (input) {
           input.value = "";
        }
      }
    };

    const initComboboxes = () => {
      const comboboxes = root.querySelectorAll('[data-combobox]');
      comboboxes.forEach(combobox => {
        const input = combobox.querySelector('[data-combobox-input]');
        const list = combobox.querySelector('[data-combobox-list]');
        const select = combobox.querySelector('select');
        if (!input || !list || !select) return;

        let closeTimeout;

        input.addEventListener('focus', () => {
          clearTimeout(closeTimeout);
          list.classList.remove('hidden');
          Array.from(list.children).forEach(child => {
            child.style.display = 'block';
          });
        });

        input.addEventListener('input', (e) => {
          const query = e.target.value.toLowerCase().trim();
          list.classList.remove('hidden');
          Array.from(list.children).forEach(child => {
            const title = child.dataset.title.toLowerCase();
            if (title.includes(query)) {
              child.style.display = 'block';
            } else {
              child.style.display = 'none';
            }
          });
        });

        input.addEventListener('blur', () => {
          closeTimeout = setTimeout(() => {
            list.classList.add('hidden');
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption && selectedOption.value) {
              input.value = selectedOption.text;
            } else {
              input.value = "";
            }
          }, 200);
        });

        list.addEventListener('mousedown', (e) => {
          const option = e.target.closest('.custom-checkout__combobox-option');
          if (!option) {
            e.preventDefault(); 
            return;
          }
          
          e.preventDefault();
          
          const value = option.dataset.value;
          const title = option.dataset.title;
          
          input.value = title;
          select.value = value;
          list.classList.add('hidden');
          input.blur(); // Explicitly remove focus from the input
          
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
        });
      });
    };

    const getAllDistricts = () => {
      const districtMap = new Map();
      Object.values(state.districts || {}).forEach((districtList) => {
        if (!Array.isArray(districtList)) return;
        districtList.forEach((district) => {
          if (!district?.value) return;
          districtMap.set(String(district.value), district);
        });
      });
      return Array.from(districtMap.values()).sort((left, right) =>
        String(left.title || "").localeCompare(String(right.title || ""), "en", { sensitivity: "base" })
      );
    };

    const isDhakaDistrict = () => {
      if (!districtSelect) return false;
      const districtText = getSelectedOptionText(districtSelect).toLowerCase();
      return Boolean(districtText) && districtText === dhakaDistrictName;
    };

    const getActiveItemAndQuantityCount = () => {
      return state.items.reduce(
        (acc, entry) => {
          const quantity = Math.max(0, Number(entry?.quantity) || 0);
          if (quantity > 0) acc.itemCount += 1;
          acc.quantityCount += quantity;
          return acc;
        },
        { itemCount: 0, quantityCount: 0 },
      );
    };

    const isQuantityFreeDeliveryEligible = () => {
      if (freeDeliveryItemThreshold <= 0) return false;
      const { itemCount, quantityCount } = getActiveItemAndQuantityCount();
      return (
        itemCount >= freeDeliveryItemThreshold ||
        quantityCount >= freeDeliveryItemThreshold
      );
    };

    const getSubtotal = () => {
      return state.items.reduce((sum, item) => {
        return sum + item.price * item.quantity;
      }, 0);
    };

    const isSubtotalFreeDeliveryEligible = () => {
      if (!enableFreeDeliveryBySubtotal) return false;
      const subtotal = getSubtotal();
      return subtotal > freeDeliverySubtotalAmount;
    };

    const isFreeDeliveryEligible = () => {
      const subtotalEligible = isSubtotalFreeDeliveryEligible();
      const quantityEligible = isQuantityFreeDeliveryEligible();

      if (freeDeliverySubtotalPriority) {
        return subtotalEligible || quantityEligible;
      }
      return subtotalEligible || quantityEligible;
    };

    const isDhakaSubareaSelected = () => {
      if (!isDhakaDistrict()) return false;
      return subareaValues.has(String(thanaSelect?.value || ""));
    };

    const getCurrentDeliveryFee = () => {
      if (isFreeDeliveryEligible()) {
        return 0;
      }

      if (dhakaSubareaDeliveryFee > 0 && isDhakaSubareaSelected()) {
        return dhakaSubareaDeliveryFee;
      }

      return isDhakaDistrict() ? dhakaDeliveryFee : otherDeliveryFee;
    };

    const getCurrentShippingZoneLabel = () => {
      if (isDhakaSubareaSelected()) {
        return deliveryLabelSubarea;
      }
      if (isDhakaDistrict()) {
        return deliveryLabelDhaka;
      }
      return deliveryLabelOther;
    };

    const getCurrentDeliveryMethodLabel = () => {
      if (isFreeDeliveryEligible()) {
        return "Delivery fee (Free)";
      }
      return container.dataset.deliveryLabel || "Delivery fee";
    };

    const getSelectedOptionText = (select) => {
      return select?.options?.[select.selectedIndex]?.text?.trim() || "";
    };

    const getPrimaryVariantIdForDiscounts = () => {
      const firstItem = state.items.find(
        (entry) => entry.quantity > 0 && entry.id,
      );
      return firstItem ? String(firstItem.id) : "";
    };

    const getPrimaryCheckoutItem = () => {
      return (
        state.items.find((entry) => entry.quantity > 0 && entry.id) || null
      );
    };

    const extractHandleFromUrl = (url) => {
      const match = String(url || "").match(/\/products\/([^/?#]+)/);
      return match ? match[1] : "";
    };

    const normalizeProductGidToNumeric = (gid) => {
      const raw = String(gid || "");
      const parts = raw.split("/");
      return parts[parts.length - 1] || raw;
    };

    const getQuantityOfferById = (offerId) => {
      const offers = Array.isArray(state.quantityOfferCampaign?.offers)
        ? state.quantityOfferCampaign.offers
        : [];
      return (
        offers.find((offer) => String(offer.id) === String(offerId)) || null
      );
    };

    const getQuantityOfferDiscountCents = (offer, quantity, unitPriceCents) => {
      if (!offer) return 0;
      const normalizedQuantity = Math.max(
        1,
        Math.round(toSafeNumber(quantity, 1)),
      );
      const subtotalCents =
        Math.max(0, toSafeNumber(unitPriceCents, 0)) * normalizedQuantity;
      if (subtotalCents <= 0) return 0;
      if (offer.discountType === "percentage") {
        const percent = Math.max(0, toSafeNumber(offer.discountValue, 0));
        return Math.min(
          subtotalCents,
          Math.round((subtotalCents * percent) / 100),
        );
      }
      const fixedDiscount = toCents(offer.discountValue);
      return Math.min(subtotalCents, Math.max(0, fixedDiscount));
    };

    const resolveQuantityOfferCampaign = () => {
      const campaigns = Array.isArray(state.quantityOffersConfig?.campaigns)
        ? state.quantityOffersConfig.campaigns
        : [];
      if (!campaigns.length) return null;

      const primaryItem = getPrimaryCheckoutItem();
      const activeCampaigns = campaigns.filter(
        (campaign) =>
          campaign?.active &&
          Array.isArray(campaign?.offers) &&
          campaign.offers.length,
      );
      if (!activeCampaigns.length) return null;

      const currentHandle = primaryItem
        ? extractHandleFromUrl(primaryItem.url)
        : productHandle;
      const currentProductId = productId ? String(productId) : "";

      const matchedCampaign = activeCampaigns.find((campaign) => {
        const products = Array.isArray(campaign?.products)
          ? campaign.products
          : [];
        return products.some((product) => {
          const productHandleValue = String(product?.handle || "");
          const productIdValue = String(
            normalizeProductGidToNumeric(product?.id || ""),
          );
          return (
            (currentHandle &&
              productHandleValue &&
              currentHandle === productHandleValue) ||
            (currentProductId &&
              productIdValue &&
              currentProductId === productIdValue)
          );
        });
      });

      return matchedCampaign || null;
    };

    const applyQuantityOfferSelection = (offerId) => {
      const primaryItem = getPrimaryCheckoutItem();
      const selectedOffer = getQuantityOfferById(offerId);
      if (!primaryItem || !selectedOffer) return;

      state.selectedQuantityOfferId = String(selectedOffer.id);
      const targetQuantity = Math.max(
        1,
        Math.round(toSafeNumber(selectedOffer.quantity, 1)),
      );
      primaryItem.quantity = targetQuantity;

      renderQuantityOffers();
      renderItems();
      // pushBeginCheckoutEvent(true);
    };

    const renderQuantityOffers = () => {
      if (!quantityOffersRoot) return;
      const campaign = state.quantityOfferCampaign;
      const offers = Array.isArray(campaign?.offers) ? campaign.offers : [];
      const primaryItem = getPrimaryCheckoutItem();

      if (!campaign || !offers.length || !primaryItem) {
        quantityOffersRoot.innerHTML = "";
        quantityOffersRoot.classList.add("hidden");
        return;
      }

      const design = campaign.design || {};
      const selectedBorderColor = String(
        design.selectedBorderColor || "#ef4444",
      );
      const selectedBackgroundColor = String(
        design.selectedBackgroundColor || "#ffffff",
      );
      const unselectedBorderColor = String(
        design.unselectedBorderColor || "#d1d5db",
      );
      const unselectedBackgroundColor = String(
        design.unselectedBackgroundColor || "#ffffff",
      );
      const radius = Math.max(4, toSafeNumber(design.radius, 10));

      quantityOffersRoot.classList.remove("hidden");
      quantityOffersRoot.innerHTML = offers
        .map((offer) => {
          const isSelected =
            String(offer.id) === String(state.selectedQuantityOfferId);
          const quantity = Math.max(
            1,
            Math.round(toSafeNumber(offer.quantity, 1)),
          );
          const compareCents = Math.max(
            0,
            toSafeNumber(primaryItem.price, 0) * quantity,
          );
          const offerDiscountCents = getQuantityOfferDiscountCents(
            offer,
            quantity,
            primaryItem.price,
          );
          const finalCents = Math.max(0, compareCents - offerDiscountCents);
          const labelText = String(offer.labelText || "").trim();
          const tagText = String(offer.tagText || "").trim();

          return `
              <button
                type="button"
                class="custom-checkout__offer-card${isSelected ? " is-selected" : ""}"
                data-quantity-offer-id="${String(offer.id)}"
                style="
                  --offer-bg: ${isSelected ? selectedBackgroundColor : unselectedBackgroundColor};
                  --offer-border: ${isSelected ? selectedBorderColor : unselectedBorderColor};
                  --offer-radius: ${radius}px;
                "
              >
                ${labelText ? `<span class="custom-checkout__offer-label">${labelText}</span>` : ""}
                <div class="custom-checkout__offer-main">
                  <div class="custom-checkout__offer-copy">
                    <strong>${String(offer.title || `Buy ${quantity} items`)}</strong>
                    ${
                      tagText
                        ? `<span class="custom-checkout__offer-tag">${tagText} ${formatMoney(
                            offerDiscountCents,
                          )}</span>`
                        : ""
                    }
                  </div>
                  <div class="custom-checkout__offer-prices">
                    ${offerDiscountCents > 0 ? `<del>${formatMoney(compareCents)}</del>` : ""}
                    <strong>${formatMoney(finalCents)}</strong>
                  </div>
                </div>
              </button>
            `;
        })
        .join("");
    };

    const normalizeDiscountFromResponse = (payload) => {
      const discountValue = payload?.discount?.customerGets?.value || {};
      const graphAmountRaw =
        discountValue?.discountAmount?.amount?.amount ??
        discountValue?.discountAmount?.amount ??
        discountValue?.amount?.amount ??
        discountValue?.amount;
      const graphPercentRaw =
        discountValue?.percentage ??
        discountValue?.discountPercentage?.percentage;
      const amountRaw =
        graphAmountRaw ??
        payload?.discountAmount ??
        payload?.discount_amount ??
        payload?.amount ??
        payload?.value ??
        0;
      const amountCents = toCents(amountRaw);
      const percentRaw =
        graphPercentRaw ??
        payload?.percent ??
        payload?.percentage ??
        payload?.discountPercent ??
        0;
      const percent = toSafeNumber(percentRaw, 0);

      if (Number.isFinite(percent) && percent > 0) {
        return {
          type: "percentage",
          value: Math.min(percent, 100),
          title: payload?.discount?.title || "",
          summary: payload?.discount?.summary || "",
        };
      }

      return {
        type: "fixed",
        value: Math.max(0, amountCents),
        title: payload?.discount?.title || "",
        summary: payload?.discount?.summary || "",
      };
    };

    const hasValidDiscountPayload = (payload) => {
      if (!payload) return false;
      if (payload.matched === true) return true;

      const normalized = normalizeDiscountFromResponse(payload);
      if (normalized.type === "percentage" && normalized.value > 0) return true;
      if (normalized.type === "fixed" && normalized.value > 0) return true;

      return false;
    };

    const getDiscountAmountCents = (subtotal) => {
      if (subtotal <= 0) return 0;
      const primaryItem = getPrimaryCheckoutItem();
      const selectedOffer = getQuantityOfferById(state.selectedQuantityOfferId);
      const quantityOfferDiscountCents =
        primaryItem && selectedOffer
          ? getQuantityOfferDiscountCents(
              selectedOffer,
              primaryItem.quantity,
              primaryItem.price,
            )
          : 0;
      const subtotalAfterQuantityOffer = Math.max(
        0,
        subtotal - quantityOfferDiscountCents,
      );

      let couponDiscountCents = 0;
      if (state.couponDiscount) {
        if (state.couponDiscount.type === "percentage") {
          couponDiscountCents = Math.min(
            subtotalAfterQuantityOffer,
            Math.round(
              (subtotalAfterQuantityOffer * state.couponDiscount.value) / 100,
            ),
          );
        } else {
          couponDiscountCents = Math.min(
            subtotalAfterQuantityOffer,
            Math.max(0, Number(state.couponDiscount.value) || 0),
          );
        }
      }

      return Math.min(
        subtotal,
        Math.max(0, quantityOfferDiscountCents + couponDiscountCents),
      );
    };

    const getOrderDiscountPayload = () => {
      const primaryItem = getPrimaryCheckoutItem();
      const selectedOffer = getQuantityOfferById(state.selectedQuantityOfferId);
      const quantityOfferDiscountCents =
        primaryItem && selectedOffer
          ? getQuantityOfferDiscountCents(
              selectedOffer,
              primaryItem.quantity,
              primaryItem.price,
            )
          : 0;

      if (!state.couponDiscount && !quantityOfferDiscountCents) return null;

      if (state.couponDiscount?.type === "percentage") {
        const rawPercent = Number(state.couponDiscount.value || 0);
        const ratio = rawPercent > 1 ? rawPercent / 100 : rawPercent;
        const normalizedRatio = Math.min(Math.max(ratio, 0), 1);
        if (normalizedRatio <= 0) return null;

        return {
          type: "percentage",
          value: normalizedRatio,
          title:
            state.couponDiscount.title ||
            state.couponCode ||
            selectedOffer?.title ||
            "Discount",
        };
      }

      const couponAmountCents = state.couponDiscount
        ? Math.max(0, Math.round(Number(state.couponDiscount.value || 0)))
        : 0;
      const amountCents = couponAmountCents + quantityOfferDiscountCents;
      if (amountCents <= 0) return null;

      return {
        type: "amount",
        value: amountCents,
        title:
          (selectedOffer?.title &&
            state.couponCode &&
            `${selectedOffer.title} + ${state.couponCode}`) ||
          selectedOffer?.title ||
          state.couponDiscount?.title ||
          state.couponCode ||
          "Discount",
      };
    };

    const getDiscountDisplayLabel = () => {
      const selectedOffer = getQuantityOfferById(state.selectedQuantityOfferId);
      if (!state.couponDiscount && !selectedOffer) return "Discount";
      if (selectedOffer && !state.couponDiscount) {
        return `Discount (${selectedOffer.title || "Quantity offer"})`;
      }
      if (selectedOffer && state.couponDiscount) {
        const couponPart = state.couponCode ? ` + ${state.couponCode}` : "";
        return `Discount (${selectedOffer.title || "Quantity offer"}${couponPart})`;
      }
      const codeText = state.couponCode ? `${state.couponCode} - ` : "";
      if (state.couponDiscount.type === "percentage") {
        return `Discount (${codeText}${state.couponDiscount.value}%)`;
      }
      return `Discount (${codeText}${formatMoney(state.couponDiscount.value)})`;
    };

    const applyCoupon = async () => {
      if (!couponInput || state.couponApplying) return;

      const couponCode = String(couponInput.value || "").trim();
      if (!couponCode) {
        window.alert("Please enter a coupon code.");
        return;
      }

      const variantId = getPrimaryVariantIdForDiscounts();
      if (!variantId) {
        window.alert("No valid product found for coupon.");
        return;
      }

      try {
        state.couponApplying = true;
        if (couponApplyButton) couponApplyButton.disabled = true;

        const shop = window.Shopify?.shop || window.location.hostname;
        const payload = await fetchJson(couponDiscountEndpoint, {
          method: "POST",
          body: JSON.stringify({
            shop,
            code: couponCode,
            variantId,
          }),
        });

        if (hasValidDiscountPayload(payload)) {
          state.couponDiscount = normalizeDiscountFromResponse(payload);
          state.couponCode = couponCode;
          setAlert("");
        } else {
          state.couponDiscount = null;
          state.couponCode = null;
          window.alert("Coupon not valid for this item.");
        }

        updateTotals();
        // pushBeginCheckoutEvent(true);
      } catch (error) {
        state.couponDiscount = null;
        state.couponCode = null;
        window.alert(error?.message || "Failed to apply coupon.");
        updateTotals();
        // pushBeginCheckoutEvent(true);
      } finally {
        state.couponApplying = false;
        if (couponApplyButton) couponApplyButton.disabled = false;
      }
    };

    const updateCodLabel = () => {
      if (!codLabelNode) return;
      codLabelNode.textContent = isDhakaDistrict()
        ? codLabelDhaka
        : codLabelOther;
    };

    const renderDistrictOptions = (selectedValue = "") => {
      const districts = getAllDistricts();
      renderSelectOptions(
        districtSelect,
        districts,
        container.dataset.districtPlaceholder || "Select district",
        selectedValue,
      );
      renderThanaOptions("", "");
    };

    const renderThanaOptions = (districtValue, selectedValue = "") => {
      const thanas = state.upazilas[String(districtValue)] || [];
      renderSelectOptions(
        thanaSelect,
        thanas,
        container.dataset.thanaPlaceholder || "Select thana / sub district",
        selectedValue,
      );
    };

    const renderPayments = () => {
      paymentButtons.forEach((button) => {
        button.classList.toggle(
          "is-active",
          button.dataset.paymentValue === state.selectedPayment,
        );
      });
    };

    const normalizePriceToCents = (price) => {
      const numericPrice = Number(price);
      if (!Number.isFinite(numericPrice)) return 0;
      if (numericPrice < 100 && numericPrice > 0) {
        return Math.round(numericPrice * 100);
      }
      if (numericPrice >= 100 && !String(price).includes(".")) {
        return numericPrice;
      }
      if (String(price).includes(".")) {
        return Math.round(numericPrice * 100);
      }
      return numericPrice;
    };

    const splitFullName = (fullName) => {
      const normalized = String(fullName || "")
        .trim()
        .replace(/\s+/g, " ");

      if (!normalized) {
        return {
          firstName: "First",
          lastName: ".",
        };
      }

      const parts = normalized.split(" ");
      const firstName = parts.shift() || "First";
      const lastName = parts.join(" ").trim() || ".";

      return { firstName, lastName };
    };

    const buildAddress = () => {
      if (!formElements.address) return "";
      return [
        formElements.address.value.trim(),
        getSelectedOptionText(thanaSelect),
        getSelectedOptionText(districtSelect),
      ]
        .filter(Boolean)
        .join(", ");
    };

    const getActiveItemCount = () => {
      return state.items.filter(
        (entry) => Math.max(0, Number(entry?.quantity) || 0) > 0,
      ).length;
    };

    const getActiveQuantityCount = () => {
      return state.items.reduce((sum, entry) => {
        return sum + Math.max(0, Number(entry?.quantity) || 0);
      }, 0);
    };

    const getCheckoutSummary = () => {
      const subtotal = getSubtotal();
      const districtText = getSelectedOptionText(districtSelect).toLowerCase();
      const isDhaka =
        Boolean(districtText) && districtText === dhakaDistrictName;
      const isSubarea =
        isDhaka && subareaValues.has(String(thanaSelect?.value || ""));

      const activeItemCount = getActiveItemCount();
      const activeQuantityCount = getActiveQuantityCount();

      const isSubtotalFreeDeliveryEligible =
        enableFreeDeliveryBySubtotal && subtotal > freeDeliverySubtotalAmount;
      const isQuantityFreeDeliveryEligible =
        freeDeliveryItemThreshold > 0 &&
        (activeItemCount >= freeDeliveryItemThreshold ||
          activeQuantityCount >= freeDeliveryItemThreshold);

      let freeDelivery = false;

      if (freeDeliverySubtotalPriority) {
        freeDelivery =
          isSubtotalFreeDeliveryEligible || isQuantityFreeDeliveryEligible;
      } else {
        freeDelivery =
          isSubtotalFreeDeliveryEligible || isQuantityFreeDeliveryEligible;
      }

      let shippingFee = 0;
      if (state.items.length && districtSelect && districtSelect.value) {
        if (freeDelivery) {
          shippingFee = 0;
        } else if (dhakaSubareaDeliveryFee > 0 && isSubarea) {
          shippingFee = dhakaSubareaDeliveryFee;
        } else {
          shippingFee = isDhaka ? dhakaDeliveryFee : otherDeliveryFee;
        }
      }

      const shippingZoneLabel = isSubarea
        ? deliveryLabelSubarea
        : isDhaka
          ? deliveryLabelDhaka
          : deliveryLabelOther;

      const deliveryMethodLabel = freeDelivery
        ? "Delivery fee (Free)"
        : container.dataset.deliveryLabel || "Delivery fee";

      const discountAmount = getDiscountAmountCents(subtotal);
      const total = Math.max(0, subtotal + shippingFee - discountAmount);

      return {
        subtotal,
        shippingFee,
        discountAmount,
        total,
        isDhaka,
        isSubarea,
        freeDelivery,
        shippingZoneLabel,
        deliveryMethodLabel,
      };
    };

    const getFreeDeliveryEligibilityStatus = () => {
      const subtotal = getSubtotal();
      const activeItemCount = getActiveItemCount();
      const activeQuantityCount = getActiveQuantityCount();

      const isSubtotalEligible =
        enableFreeDeliveryBySubtotal && subtotal > freeDeliverySubtotalAmount;
      const isQuantityEligible =
        freeDeliveryItemThreshold > 0 &&
        (activeItemCount >= freeDeliveryItemThreshold ||
          activeQuantityCount >= freeDeliveryItemThreshold);

      let subtotalNeeded = 0;
      if (
        enableFreeDeliveryBySubtotal &&
        subtotal <= freeDeliverySubtotalAmount
      ) {
        subtotalNeeded = freeDeliverySubtotalAmount + 1 - subtotal;
      }

      const quantityNeeded = freeDeliveryItemThreshold - activeQuantityCount;

      return {
        isSubtotalEligible,
        isQuantityEligible,
        isEligible: isSubtotalEligible || isQuantityEligible,
        subtotalNeeded: Math.max(0, subtotalNeeded),
        quantityNeeded: Math.max(0, quantityNeeded),
        enableSubtotal: enableFreeDeliveryBySubtotal,
        subtotalThreshold: freeDeliverySubtotalAmount,
        quantityThreshold: freeDeliveryItemThreshold,
        subtotal,
        activeItemCount,
        activeQuantityCount,
      };
    };

    const renderFreeDeliveryProgress = () => {
      if (!progressContainer) return;

      const eligibility = getFreeDeliveryEligibilityStatus();

      if (
        eligibility.isEligible ||
        (!eligibility.enableSubtotal && freeDeliveryItemThreshold <= 0)
      ) {
        progressContainer.classList.add("hidden");
        return;
      }

      progressContainer.classList.remove("hidden");

      let progressHtml =
        '<div class="custom-checkout__free-delivery-progress">';

      if (
        eligibility.enableSubtotal &&
        eligibility.subtotalThreshold > 0 &&
        !eligibility.isSubtotalEligible
      ) {
        let percent =
          (eligibility.subtotal / eligibility.subtotalThreshold) * 100;
        percent = Math.min(100, Math.max(0, percent));

        const remainingAmount = eligibility.subtotalNeeded;

        progressHtml += `
          <div class="custom-checkout__free-delivery-message">
            <i class="fa-solid fa-truck-fast"></i>
            <span>Add ${formatMoney(remainingAmount)} more to get FREE delivery!</span>
          </div>
          <div class="custom-checkout__progress-bar">
            <div class="custom-checkout__progress-fill" style="width: ${percent}%"></div>
          </div>
        `;
      } else if (
        freeDeliveryItemThreshold > 0 &&
        !eligibility.isQuantityEligible &&
        !eligibility.isSubtotalEligible
      ) {
        const percent = Math.min(
          100,
          ((freeDeliveryItemThreshold - eligibility.quantityNeeded) /
            freeDeliveryItemThreshold) *
            100,
        );
        progressHtml += `
          <div class="custom-checkout__free-delivery-message">
            <i class="fa-solid fa-truck-fast"></i>
            <span>Add ${eligibility.quantityNeeded} more item${eligibility.quantityNeeded !== 1 ? "s" : ""} to get FREE delivery!</span>
          </div>
          <div class="custom-checkout__progress-bar">
            <div class="custom-checkout__progress-fill" style="width: ${percent}%"></div>
          </div>
        `;
      }

      progressHtml += "</div>";
      progressContainer.innerHTML = progressHtml;
    };
    //  const pushFacebookInitiateCheckoutEvent = (force = false) => {
    //   try {
    //     if (!isMetaPixelReady()) return;
    //     if (!state.items || !state.items.length) return;
    //     if (!force && root.dataset.fbInitiateCheckoutTracked === "true") return;
    //     const totals = getCheckoutSummary();
    //     const contents = getFacebookPixelItems();
    //     window.fbq("track", "InitiateCheckout", {
    //       content_ids: contents.map((item) => item.id),
    //       content_type: "product",
    //       contents: contents,
    //       num_items: contents.reduce((sum, item) => sum + item.quantity, 0),
    //       value: totals.total / 100,
    //       currency: currencyCode,
    //     });

    //     root.dataset.fbInitiateCheckoutTracked = "true";
    //   } catch (error) {
    //     console.warn("Facebook Pixel InitiateCheckout failed", error);
    //   }
    // };
    // const pushFacebookPurchaseEvent = (orderId = "") => {
    //   try {
    //     if (!isMetaPixelReady()) return;
    //     if (!state.items || !state.items.length) return;

    //     const totals = getCheckoutSummary();
    //     const contents = getFacebookPixelItems();

    //     window.fbq("track", "Purchase", {
    //       content_ids: contents.map((item) => item.id),
    //       content_type: "product",
    //       contents: contents,
    //       num_items: contents.reduce((sum, item) => sum + item.quantity, 0),
    //       value: totals.total / 100,
    //       currency: currencyCode,
    //       order_id: orderId || undefined,
    //     });
    //   } catch (error) {
    //     console.warn("Facebook Pixel Purchase failed", error);
    //   }
    // };
    const updateTotals = () => {
      const summary = getCheckoutSummary();

      if (subtotalNode)
        subtotalNode.textContent = formatMoney(summary.subtotal);
      if (deliveryNode)
        deliveryNode.textContent = formatMoney(summary.shippingFee);
      if (deliveryLabelNode)
        deliveryLabelNode.textContent = summary.deliveryMethodLabel;
      if (discountNode)
        discountNode.textContent = formatMoney(summary.discountAmount);
      if (discountLabelNode)
        discountLabelNode.textContent = getDiscountDisplayLabel();
      if (discountRowNode)
        discountRowNode.classList.toggle("hidden", summary.discountAmount <= 0);
      if (totalNode) totalNode.textContent = formatMoney(summary.total);

      updateCodLabel();
      renderFreeDeliveryProgress();
    };

    const renderEmptyState = () => {
      if (!itemsNode) return;
      itemsNode.innerHTML = `
          <div class="custom-checkout__empty">
            <h3>${container.dataset.emptyStateHeading || "No product selected"}</h3>
            <p>${emptyStateText}</p>
          </div>
        `;
    };

    const renderItems = () => {
      if (!itemsNode) return;
      if (!state.items.length) {
        renderEmptyState();
        updateTotals();
        return;
      }

      itemsNode.innerHTML = state.items
        .map((item, index) => {
          const variantTitle =
            item.variantTitle && item.variantTitle !== "Default Title"
              ? `<p class="custom-checkout__item-variant">${item.variantTitle}</p>`
              : "";
          const image = item.image
            ? `<img src="${item.image}" alt="${item.title}" loading="lazy">`
            : `<div class="custom-checkout__item-image-placeholder">${item.title.charAt(0)}</div>`;

          return `
              <article class="custom-checkout__item" data-item-index="${index}">
                <div class="custom-checkout__item-image">${image}</div>
                <div class="custom-checkout__item-content">
                  <div class="custom-checkout__item-copy">
                    <h3>${escapeHtml(item.title)}</h3>
                    ${variantTitle}
                    <strong>${formatMoney(item.price)}</strong>
                  </div>
                  <div class="custom-checkout__item-actions">
                    <div class="custom-checkout__quantity">
                      <button type="button" data-quantity-action="decrease" aria-label="Decrease quantity">-</button>
                      <input type="number" min="1" value="${item.quantity}" data-quantity-input>
                      <button type="button" data-quantity-action="increase" aria-label="Increase quantity">+</button>
                    </div>
                    <button type="button" class="custom-checkout__remove" data-remove-item><i class="fa-solid fa-trash"></i></button>
                  </div>
                </div>
              </article>
            `;
        })
        .join("");

      updateTotals();
    };

    const escapeHtml = (text) => {
      if (!text) return "";
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    };

    const normalizeProductItem = (
      product,
      variant,
      quantity,
      currencyCode = "USD",
    ) => {
      const variantImage =
        variant.featured_image?.src || variant.featured_image?.url || "";

      const productImage =
        typeof product.featured_image === "string"
          ? product.featured_image
          : product.featured_image?.src || product.featured_image?.url || "";

      const fallbackImage =
        Array.isArray(product.images) && product.images.length
          ? typeof product.images[0] === "string"
            ? product.images[0]
            : product.images[0]?.src || product.images[0]?.url || ""
          : "";

      const image = variantImage || productImage || fallbackImage;
      const rawPrice = variant.price;
      let price = 0;

      const isBDT = currencyCode === "BDT";
      if (typeof rawPrice === "string") {
        const cleanPrice = parseFloat(rawPrice);

        if (!isNaN(cleanPrice)) {
          if (isBDT) {
            price = Math.round(cleanPrice);
          } else {
            price = Math.round(cleanPrice * 100);
          }
        }
      } else if (typeof rawPrice === "number") {
        if (isBDT) {
          if (rawPrice >= 100 && rawPrice % 1 === 0) {
            price = Math.round(rawPrice);
          } else {
            price = Math.round(rawPrice * 100);
          }
        } else {
          if (rawPrice >= 100 && rawPrice % 1 === 0) {
            price = rawPrice;
          } else {
            price = Math.round(rawPrice * 100);
          }
        }
      }
      if (!Number.isFinite(price) || price < 0) {
        price = 0;
      }

      const quantityNum = Math.max(1, Number(quantity) || 1);

      return {
        id: variant.id,
        key: String(variant.id),

        title: product.title,
        variantTitle: variant.title,

        quantity: quantityNum,
        price,
        unitPriceCents: price,

        finalLinePriceCents: price * quantityNum,

        image,

        url: `/products/${product.handle}`,
      };
    };

    const normalizeCartItem = (item) => {
      const image = item?.featured_image?.url || item?.image || "";
      const resolvedVariantId = item?.variant_id || item?.id;
      const variantTitle =
        item?.variant_title && item.variant_title !== "Default Title"
          ? item.variant_title
          : "";

      const priceCents = normalizePriceToCents(item?.price);
      const quantityNum = Math.max(1, Number(item?.quantity) || 1);

      return {
        id: resolvedVariantId,
        key: String(item?.key || resolvedVariantId || ""),
        title: item?.product_title || item?.title || "",
        variantTitle,
        quantity: quantityNum,
        price: priceCents,
        unitPriceCents: priceCents,
        finalLinePriceCents: priceCents * quantityNum,
        image,
        url: item?.url || item?.product_url || "#",
      };
    };

    const loadProductById = async () => {
      const targetProductId = String(productId);
      const targetVariantId = String(variantId);
      let page = 1;

      while (page <= 10) {
        const response = await fetchJson(
          `/products.json?limit=250&page=${page}`,
          { method: "GET" },
        );
        const products = Array.isArray(response?.products)
          ? response.products
          : [];

        const matchedProduct = products.find((product) => {
          if (String(product.id) === targetProductId) return true;

          return Array.isArray(product.variants)
            ? product.variants.some(
                (variant) => String(variant.id) === targetVariantId,
              )
            : false;
        });

        if (matchedProduct) {
          return matchedProduct;
        }

        if (products.length < 250) break;
        page += 1;
      }

      throw new Error("product-unavailable");
    };

    const loadCheckoutItems = async () => {
      const itemsByVariantId = new Map();

      if (useCartFallback) {
        const cart = await fetchJson("/cart.js", { method: "GET" });
        const cartItems = Array.isArray(cart?.items) ? cart.items : [];

        cartItems
          .map(normalizeCartItem)
          .filter((item) => item.id)
          .forEach((item) => {
            itemsByVariantId.set(String(item.id), item);
          });
      }

      if (productHandle) {
        const product = productId
          ? await loadProductById()
          : await fetchJson(
              `/products/${encodeURIComponent(productHandle)}.js`,
              { method: "GET" },
            );
        const variant =
          product.variants.find(
            (item) => String(item.id) === String(variantId),
          ) ||
          product.variants.find((item) => item.available) ||
          product.variants[0];

        if (!variant || !product) {
          throw new Error("product-unavailable");
        }

        const urlItem = normalizeProductItem(
          product,
          variant,
          requestedQuantity,
        );
        const existingItem = itemsByVariantId.get(String(urlItem.id));

        if (existingItem) {
          existingItem.quantity += urlItem.quantity;
          itemsByVariantId.set(String(urlItem.id), existingItem);
        } else {
          itemsByVariantId.set(String(urlItem.id), urlItem);
        }
      }

      state.items = Array.from(itemsByVariantId.values());
    };

    const clearCart = async () => {
      await fetchJson("/cart/clear.js", {
        method: "POST",
        body: JSON.stringify({}),
      });
    };

    const validateForm = () => {
      setAlert("");
      syncPhoneInput();

      if (!state.items.some((item) => item.quantity > 0)) {
        setAlert(emptyStateText);
        return false;
      }

      let firstInvalid = null;

      checkoutControls.forEach((control) => {
        control.removeAttribute("aria-invalid");
        if (!control.checkValidity()) {
          control.setAttribute("aria-invalid", "true");
          if (!firstInvalid) firstInvalid = control;
        }
      });

      if (firstInvalid) {
        firstInvalid.focus();
        setAlert(firstInvalid.validationMessage || genericErrorMessage);
        return false;
      }

      return true;
    };

    const updateItemQuantity = (index, quantity) => {
      const normalizedQuantity = Math.max(1, Number(quantity) || 1);
      if (!state.items[index]) return;
      if (state.items[index].quantity === normalizedQuantity) return;
      state.items[index].quantity = normalizedQuantity;
      if (index === 0 && state.selectedQuantityOfferId) {
        const selectedOffer = getQuantityOfferById(
          state.selectedQuantityOfferId,
        );
        const selectedQuantity = Math.max(
          1,
          Math.round(toSafeNumber(selectedOffer?.quantity, 1)),
        );
        if (!selectedOffer || normalizedQuantity !== selectedQuantity) {
          state.selectedQuantityOfferId = null;
        }
        renderQuantityOffers();
      }
      renderItems();
      // pushBeginCheckoutEvent(true);
    };

    const removeItem = (index) => {
      if (!state.items[index]) return;
      state.items.splice(index, 1);
      state.quantityOfferCampaign = resolveQuantityOfferCampaign();
      if (!state.quantityOfferCampaign) {
        state.selectedQuantityOfferId = null;
      }
      renderQuantityOffers();
      renderItems();
      // pushBeginCheckoutEvent(true);
    };

    const buildPayload = async () => {
      const lineItems = state.items
        .filter((entry) => entry.quantity > 0 && entry.id)
        .map((entry) => {
          const numericVariantId = Number(entry.id);
          const resolvedVariantId = Number.isFinite(numericVariantId)
            ? String(numericVariantId)
            : String(entry.id);

          const quantity = Math.max(1, Number(entry.quantity) || 1);
          const unitPriceCents = Math.max(0, toSafeNumber(entry.price, 0));
          const finalLinePriceCents = unitPriceCents * quantity;

          return {
            variantId: resolvedVariantId,
            quantity: quantity,
            finalLinePriceCents: finalLinePriceCents,
            unitPriceCents: unitPriceCents,
          };
        });

      if (!lineItems.length) {
        throw new Error(emptyStateText);
      }

      const { firstName, lastName } = splitFullName(
        formElements.full_name?.value,
      );
      const note = formElements.note?.value?.trim() || "";

      const primaryLineItem = lineItems[0];
      const summary = getCheckoutSummary();
      const discountPayload = getOrderDiscountPayload();

      const shippingPayload = {
        label: summary.shippingZoneLabel,
        priceCents: summary.shippingFee,
      };

      return {
        shop: window.Shopify?.shop || window.location.hostname,

        variantId: primaryLineItem.variantId,
        quantity: primaryLineItem.quantity,

        shippingPriceCents: summary.shippingFee,
        shippingPrice: summary.shippingFee / 100,
        shipping: shippingPayload,
        deliveryMethodLabel: summary.shippingZoneLabel,

        couponCode: state.couponCode,
        couponDiscount: state.couponDiscount,
        discount: discountPayload,

        discountAmountCents: summary.discountAmount,
        discountAmount: summary.discountAmount / 100,

        subtotalPriceCents: summary.subtotal,
        subtotalPrice: summary.subtotal / 100,

        finalPriceCents: summary.total,
        finalPrice: summary.total / 100,

        totalPriceCents: summary.total,
        totalPrice: summary.total / 100,

        currency: currencyCode,
        lineItems,

        quantityOffer: state.selectedQuantityOfferId
          ? getQuantityOfferById(state.selectedQuantityOfferId)
          : null,

        customer: {
          firstName,
          lastName,
          phone: syncPhoneInput(),
          address1: buildAddress(),
          ...(note ? { note } : {}),
        },
      };
    };

    const addCurrentItemToCart = async () => {
      const item = state.items.find((entry) => entry.quantity > 0);

      if (!item) {
        throw new Error(emptyStateText);
      }

      await fetchJson("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({
          id: item.id,
          quantity: Math.max(1, Number(item.quantity) || 1),
        }),
      });
    };
    // const isMetaPixelReady = () => {
    //   return typeof window.fbq === "function";
    // };

    // const getFacebookPixelItems = () => {
    //   return state.items
    //     .filter((item) => item.quantity > 0)
    //     .map((item) => ({
    //       id: String(item.id || ""),
    //       quantity: Number(item.quantity || 1),
    //       item_price: item.price ? item.price / 100 : 0,
    //     }));
    // };

    // const pushBeginCheckoutEvent = (force = false) => {
    //   try {
    //     if (!state.items || !state.items.length) return;
    //     if (!force && root.dataset.beginCheckoutTracked === "true") return;

    //     const totals = getCheckoutSummary();

    //     const items = state.items
    //       .filter((item) => item.quantity > 0)
    //       .map((item) => ({
    //         item_name: item.title || "Unknown Product",
    //         item_id: String(item.id || ""),
    //         item_variant: item.variantTitle || "",
    //         price: item.price ? item.price / 100 : 0,
    //         quantity: item.quantity || 1,
    //       }));

        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({ ecommerce: null });
        // window.dataLayer.push({
        //   event: "begin_checkout",
        //   ecommerce: {
        //     currency: currencyCode,
        //     value: totals.total / 100,
        //     coupon: state.couponCode || undefined,
        //     shipping: totals.shippingFee / 100,
        //     items: items,
        //     customer: {
        //       phone: syncPhoneInput() || "",
        //       city: getSelectedOptionText(districtSelect),
        //     },
        //   },
        // });
      //  pushFacebookInitiateCheckoutEvent(force);
        // root.dataset.beginCheckoutTracked = "true";
    //   } catch (error) {
    //     console.warn("GTM begin_checkout push failed", error);
    //   }
    // };

    const attachItemEvents = () => {
      if (!itemsNode) return;
      itemsNode.addEventListener("click", (event) => {
        const item = event.target.closest("[data-item-index]");
        if (!item) return;
        const index = Number(item.dataset.itemIndex);

        if (event.target.closest('[data-quantity-action="increase"]')) {
          event.preventDefault();
          updateItemQuantity(index, (state.items[index]?.quantity || 0) + 1);
        }

        if (event.target.closest('[data-quantity-action="decrease"]')) {
          event.preventDefault();
          updateItemQuantity(index, (state.items[index]?.quantity || 0) - 1);
        }

        if (event.target.closest("[data-remove-item]")) {
          event.preventDefault();
          const targetVariantId = state.items[index]?.id;
          removeItem(index);
          
          if (targetVariantId) {
            fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: String(targetVariantId),
                quantity: 0
              })
            })
            .then(res => res.json())
            .then(cart => {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
            }).catch(() => {});
          }
        }
      });

      itemsNode.addEventListener("change", (event) => {
        const item = event.target.closest("[data-item-index]");
        if (!item || !event.target.matches("[data-quantity-input]")) return;
        updateItemQuantity(Number(item.dataset.itemIndex), event.target.value);
      });
    };

    function onThankYouEscape(event) {
      if (event.key !== "Escape") return;
      event.preventDefault();
      closeThankYouModal();
    }

    const closeThankYouModal = () => {
      const t = getThankYouParts();
      if (t?.overlay) {
        t.overlay.classList.add("hidden");
        t.overlay.setAttribute("aria-hidden", "true");
      }
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onThankYouEscape);
      state.suppressSubmitReset = false;
      resetSubmitButtonState();
      if (submitButton) submitButton.disabled = false;
    };

    const openThankYouModal = (redirectUrl, orderName) => {
      const t = getThankYouParts();
      if (!t?.overlay || !t.dialog) {
        window.location.href = redirectUrl;
        return;
      }
      if (t.titleEl) {
        t.titleEl.textContent =
          container.dataset.thankYouHeading || "Thank you!";
      }
      if (t.messageEl) {
        t.messageEl.textContent = container.dataset.thankYouMessage || "";
      }
      if (t.orderLineEl) {
        if (orderName) {
          t.orderLineEl.textContent = `Order ${orderName}`;
          t.orderLineEl.classList.remove("hidden");
        } else {
          t.orderLineEl.textContent = "";
          t.orderLineEl.classList.add("hidden");
        }
      }
      if (t.statusLinkEl) {
        t.statusLinkEl.setAttribute("href", redirectUrl);
        t.statusLinkEl.textContent =
          container.dataset.thankYouViewOrderLabel || "View order status";
      }
      t.overlay.classList.remove("hidden");
      t.overlay.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", onThankYouEscape);
      queueMicrotask(() => {
        t.dialog.focus();
      });
    };

    const wireThankYouUi = () => {
      const t = getThankYouParts();
      if (!t?.closeEl || !t.overlay) return;
      t.closeEl.addEventListener("click", closeThankYouModal);
      t.overlay.addEventListener("click", (event) => {
        if (event.target === t.overlay) closeThankYouModal();
      });
      if (t.continueEl) {
        t.continueEl.addEventListener("click", () => {
          window.location.href = continueShoppingUrl;
        });
      }
    };

    // Event Listeners
    paymentButtons.forEach((button) => {
      button.addEventListener("click", () => {
        state.selectedPayment = button.dataset.paymentValue;
        renderPayments();
      });
    });

    if (districtSelect) {
      districtSelect.addEventListener("change", () => {
        renderThanaOptions(districtSelect.value);
        updateTotals();
      });
    }

    if (thanaSelect) {
      thanaSelect.addEventListener("change", () => {
        updateTotals();
      });
    }

    if (phoneInput) {
      ["input", "blur"].forEach((eventName) => {
        phoneInput.addEventListener(eventName, syncPhoneInput);
      });
    }

    if (continueShoppingButton) {
      continueShoppingButton.addEventListener("click", async () => {
        if (state.syncing) return;

        try {
          state.syncing = true;
          continueShoppingButton.disabled = true;
          setAlert("");
          await addCurrentItemToCart();
          window.location.href = continueShoppingUrl;
        } catch (error) {
          setAlert(error.message || genericErrorMessage);
        } finally {
          state.syncing = false;
          continueShoppingButton.disabled = false;
        }
      });
    }

    if (couponApplyButton) {
      couponApplyButton.addEventListener("click", () => {
        applyCoupon();
      });
    }

    if (couponToggleButton && couponPanelNode) {
      couponToggleButton.addEventListener("click", () => {
        const isExpanded =
          couponToggleButton.getAttribute("aria-expanded") === "true";
        couponToggleButton.setAttribute("aria-expanded", String(!isExpanded));
        couponPanelNode.classList.toggle("hidden", isExpanded);
      });
    }

    if (couponInput) {
      couponInput.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;
        event.preventDefault();
        applyCoupon();
      });
    }

    if (quantityOffersRoot) {
      quantityOffersRoot.addEventListener("click", (event) => {
        const button = event.target.closest("[data-quantity-offer-id]");
        if (!button) return;
        applyQuantityOfferSelection(button.dataset.quantityOfferId);
      });
    }

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (state.syncing) return;
      if (!validateForm()) return;

      try {
        state.syncing = true;
        if (submitButton) submitButton.disabled = true;
        runSubmitSequence();
        const payload = await buildPayload();
        const response = await fetchJson(container.dataset.createOrderUrl, {
          method: "POST",
          body: JSON.stringify(payload),
        });
        if (response?.success !== true) {
          throw new Error(genericErrorMessage);
        }
        try {
          const totals = getCheckoutSummary();
          window.dataLayer = window.dataLayer || [];
          const order =
            response?.result?.orderCreate?.order ||
            response?.result?.data?.orderCreate?.order ||
            {};
          const payloadItems = payload?.lineItems || [];
          const items = payloadItems.map((item) => {
            const domItem =
              state.items.find(
                (i) => String(i.id) === String(item.variantId),
              ) || {};
            return {
              item_name: domItem.title || "Unknown Product",
              item_id: item.variantId,
              item_variant: domItem.variantTitle || "",
              price: domItem.price ? domItem.price / 100 : 0,
              quantity: item.quantity,
            };
          });

          // window.dataLayer.push({
          //   event: "purchase",
          //   ecommerce: {
          //     transaction_id:
          //       order.id ||
          //       order.name ||
          //       response?.data?.orderCreate?.order?.name,
          //     affiliation: window.Shopify?.shop || location.hostname,
          //     value: totals.total / 100,
          //     currency: order.totalPriceSet?.shopMoney?.currencyCode || "BDT",
          //     tax: 0,
          //     shipping: totals.shippingFee / 100,
          //     items: items,
          //     customer: {
          //       first_name: payload?.customer?.firstName,
          //       last_name: payload?.customer?.lastName,
          //       phone: payload?.customer?.phone,
          //       address: payload?.customer?.address1,
          //       city: getSelectedOptionText(districtSelect),
          //     },
          //   },
          // });
          //   pushFacebookPurchaseEvent(
          //   order.name ||
          //     order.id ||
          //     response?.data?.orderCreate?.order?.name ||
          //     "",
          // );
        } catch (err) {
          console.warn("GTM purchase push failed", err);
        }

        const redirectUrl =
          response?.result?.statusJson?.orderStatusUrl ||
          response?.result?.orderStatusUrl ||
          response?.orderStatusUrl ||
          response?.redirectUrl;
        if (!redirectUrl) {
          throw new Error(genericErrorMessage);
        }

        const orderName =
          response?.result?.data?.orderCreate?.order?.name ||
          response?.result?.orderCreate?.order?.name ||
          "";

        clearCart().catch(() => {});

        if (useThankYouPopup) {
          state.suppressSubmitReset = true;
          setSubmitButtonState(
            container.dataset.thankYouHeading || submitButtonDefaultLabel,
            false,
          );
          openThankYouModal(redirectUrl, orderName);
        } else {
          setSubmitButtonState(
            container.dataset.successLabel || submitButtonDefaultLabel,
            true,
          );
          if (submitButton) submitButton.disabled = true;
          window.location.href = redirectUrl;
        }
      } catch (error) {
        state.suppressSubmitReset = false;
        resetSubmitButtonState();
        setAlert(error.message || genericErrorMessage);
      } finally {
        state.syncing = false;
        clearSubmitSequenceTimer();
        if (!state.suppressSubmitReset) {
          if (submitButton) submitButton.disabled = false;
          resetSubmitButtonState();
        }
      }
    });

    const initialize = async () => {
      initComboboxes();
      renderPayments();
      attachItemEvents();
      state.quantityOffersConfig = parseJsonSafe(quantityOffersConfigRaw, null);

      let hasError = false;
      let itemsError = false;
      let locationError = false;

      const itemsPromise = loadCheckoutItems().catch(() => {
        state.items = [];
        itemsError = true;
      });

      const locationPromise = loadLocationData()
        .then(() => {
          renderDistrictOptions();
          renderThanaOptions("");
        })
        .catch(() => {
          if (districtSelect) {
            districtSelect.innerHTML = `<option value="">${
              container.dataset.districtPlaceholder || "Select district"
            }</option>`;
            districtSelect.disabled = true;
          }
          if (thanaSelect) {
            thanaSelect.innerHTML = `<option value="">${
              container.dataset.thanaPlaceholder || "Select thana / sub district"
            }</option>`;
            thanaSelect.disabled = true;
          }
          locationError = true;
        });

      await Promise.all([itemsPromise, locationPromise]);
      hasError = itemsError || locationError;

      renderItems();
      state.quantityOfferCampaign = resolveQuantityOfferCampaign();
      if (state.quantityOfferCampaign) {
        const preselectedOffer = state.quantityOfferCampaign.offers.find(
          (offer) => Boolean(offer?.preselect),
        );
        state.selectedQuantityOfferId = preselectedOffer
          ? String(preselectedOffer.id)
          : String(state.quantityOfferCampaign.offers[0]?.id || "");
        if (state.selectedQuantityOfferId) {
          applyQuantityOfferSelection(state.selectedQuantityOfferId);
        } else {
          renderQuantityOffers();
        }
      } else {
        renderQuantityOffers();
      }

      // pushBeginCheckoutEvent();

      if (hasError && !state.items.length) {
        setAlert(container.dataset.genericError);
      } else if (hasError && state.items.length) {
        setAlert(
          "Location data could not be loaded. Please refresh or check the CDN URL.",
        );
      } else {
        setAlert("");
      }
    };

    initialize();
    wireThankYouUi();
  }

  window.initCustomCheckoutSection = initCustomCheckoutSection;
})();
